import React from "react";

/** hooks */
import { useAuth } from "@hooks/useAuth";

import useTheme from "@styles/useTheme";
import useTranslation from "@languages/useTranslation";

import SidebarDrawerMenu from "@atoms/SidebarDrawerMenu";

import { SidebarMenuItems } from "@molecules/SidebarMenus";

const SidebarDrawerMenus: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <>
      {SidebarMenuItems.map(({ id, title, icon, link, onlyAdmin }) => {
        if (onlyAdmin && !user.admin) return null;

        return (
          <SidebarDrawerMenu
            key={`${id}_${title}`}
            id={id}
            title={t(title)}
            icon={icon}
            link={link}
            secondaryColor={theme.colors.secondary}
            identifierColor={theme.colors.tertiary}
            type="primary"
          />
        );
      })}
    </>
  );
};

export default React.memo(SidebarDrawerMenus);
